import React from 'react';

/**
 * Methodology — three guiding principles. Auto-numbered when rendered inside
 * a `.numbered-sections` ancestor.
 */
export default function Methodology() {
  const principles = [
    {
      n: 'i.',
      title: 'Ein Team von Experten',
      body:
        'Wir sind Spezialisten, keine Generalisten. Jede Entscheidung wird für das Vermögen getroffen. Wir denken in Jahren, nicht Monaten.',
    },
    {
      n: 'ii.',
      title: 'Daten statt Bauchgefühl',
      body:
        'Mietpreisoptimierung, Betriebskostensteuerung, intelligentes Mahnwesen, proaktive Sanierungen. Konstante Berichterstattung an den Eigentümer.',
    },
    {
      n: 'iii.',
      title: 'Eigentümerperspektive',
      body:
        'Wir handeln in Ihrem Namen mit ausführlichen Vollmachten. Aber immer innerhalb klar definierter Grenzen. Keine Rückfragen bei jeder Rechnung — nur bei substantiellen Entscheidungen.',
    },
  ];

  return (
    <section style={{ padding: '140px 0', background: 'var(--cream-deep)' }}>
      <div className="shell">
        <div className="section-label numbered reveal" style={{ marginBottom: 28 }}>
          <span>Unsere Methode</span>
        </div>
        <h2 className="h-section reveal" style={{ marginBottom: 16, maxWidth: '20ch' }}>
          Die hamba Philosophie.
        </h2>
        <p
          className="reveal"
          style={{
            fontFamily: 'var(--serif)',
            fontStyle: 'italic',
            fontSize: 22,
            color: 'var(--charcoal-muted)',
            marginBottom: 72,
            maxWidth: '120ch',
          }}
        >
          hamba entsprang dem Family Office der Familie Balz. Auf der Suche nach einem geeigneten Partner wurde die Familie nicht fündig. Der Markt bietet nur klassische Hausverwaltungen, die vorwiegend Eigentümergemeinschaften betreuen. Asset-Management-Firmen betreuen meist nur institutionelle Kunden. Deshalb müssen private Portfolios selbst verwaltet oder an klassische Verwalter gegeben werden.
          <br />
          <br />
          Wir finden: Es ist <strong>absoluter Wahnsinn</strong>, ein derartiges Vermögen keinem Experten anzuvertrauen.
          <br />
          <br />
          Also entstand hamba. Die gesammelte Expertise stellt hamba jetzt auch anderen Immobilieninvestoren zur Verfügung. Wir sichern und mehren Ihren Wohlstand über Generationen nachhaltig.
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            gap: 0,
            borderTop: '1px solid var(--cream-line)',
            borderBottom: '1px solid var(--cream-line)',
          }}
        >
          {principles.map((p, i) => (
            <div
              key={i}
              className="reveal"
              style={{
                padding: '44px 32px 44px 0',
                paddingLeft: i === 0 ? 0 : 32,
                borderRight: i < principles.length - 1 ? '1px solid var(--cream-line)' : 'none',
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--serif)',
                  fontStyle: 'italic',
                  fontSize: 14,
                  color: 'var(--bordeaux)',
                  marginBottom: 18,
                }}
              >
                {p.n}
              </div>
              <h3 className="h-pillar" style={{ marginBottom: 16, fontSize: 22 }}>
                {p.title}
              </h3>
              <p className="body-prose" style={{ fontSize: 16 }}>
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
